import { FileTextOutlined } from '@ant-design/icons';
import type { NavigationItemType } from '~/types/navigation';

export default {
    id: 'logs',
    type: 'item',
    url: '/logs',
    icon: FileTextOutlined,
    title: 'Zapisnici',
} satisfies NavigationItemType;
